require.register("modules/m01/m01-activity/page-11/page-11", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page11 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page11;

  
});

